import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@mui/styles';
import { Grid, Button, useMediaQuery, Box } from '@mui/material';
import { SectionHeader } from 'components/molecules';

const useStyles = makeStyles(theme => ({
  videoWrapper: {
    position: 'relative',
    width: '100%',
    aspectRatio: '9 / 16', // Shorts ratio
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
    boxShadow: `0 5px 15px 0 ${theme.palette.cardShadow}`,

    [theme.breakpoints.down('sm')]: {
      boxShadow: 'none',
    },
  },
  videoIframe: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    border: 0,
  },
}));

const YT_OPTS =
  '?rel=0&modestbranding=1&controls=0&showinfo=0&playsinline=1';

const VideoSection = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  const theme = useTheme();

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <Grid container spacing={isMd ? 4 : 2} alignItems="center">
        {/* LEFT CONTENT */}
        <Grid item xs={12} md={6} data-aos="fade-up">
          <SectionHeader
            title="Every Day Science - Teachers Training Program"
            subtitle="Sci Sab focuses on supporting teachers by providing high-quality, curriculum-aligned content that actively engages students inside the classroom."
            // ctaGroup={[
            //   <Button
            //     key="contact"
            //     variant="contained"
            //     color="primary"
            //     size={isMd ? 'large' : 'medium'}
            //     href="/#home-contact"
            //   >
            //     Contact us
            //   </Button>,
            // ]}
            align={isMd ? 'left' : 'center'}
            disableGutter
            titleVariant="h3"
          />
        </Grid>

        {/* RIGHT VIDEOS */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            {/* SHORT 1 */}
            <Grid item xs={6}>
              <Box className={classes.videoWrapper}>
                <iframe
                  className={classes.videoIframe}
                  title="Short video 1"
                  src={`https://www.youtube.com/embed/rCJoyascenw${YT_OPTS}`}
                  allow="autoplay; encrypted-media; picture-in-picture"
                  allowFullScreen
                />
              </Box>
            </Grid>

            {/* SHORT 2 */}
            <Grid item xs={6}>
              <Box className={classes.videoWrapper}>
                <iframe
                  className={classes.videoIframe}
                  title="Short video 2"
                  src={`https://www.youtube.com/embed/GtVZknj9JdM${YT_OPTS}`}
                  allow="autoplay; encrypted-media; picture-in-picture"
                  allowFullScreen
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};


VideoSection.propTypes = {
  className: PropTypes.string,
};

export default VideoSection;
